<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol lg="6">
          
          <!-- Alert -->
          <CAlert
            :color="getColor"
            closeButton
            :show.sync="dismissCountDown"
            fade
          >
            {{ msg }}
          </CAlert>

          <CCard class="shadow border-0">
            
            <!-- Header -->
            <CCardHeader class="bg-white border-bottom">
              <div class="d-flex align-items-center">
                <CIcon name="cil-bell" size="lg" class="mr-2 text-primary" />
                <div>
                  <h4 class="mb-0">Notification Management</h4>
                  <small class="text-muted">
                    Send notifications to users
                  </small>
                </div>
              </div>
            </CCardHeader>

            <!-- Body -->
            <CCardBody>
              <CForm @submit.prevent="onSubmit">

                <!-- Notification Message -->
                <div class="form-group">
                  <label><strong>Message</strong></label>
                  <textarea
                    class="form-control"
                    rows="4"
                    v-model="form.message"
                    placeholder="Enter notification message"
                  ></textarea>
                </div>

                <!-- User Type -->
                <div class="form-group">
                  <label><strong>Select User Type</strong></label>

                  <div class="custom-control custom-radio mb-2">
                    <input
                      type="radio"
                      id="industry"
                      value="Industry"
                      v-model="form.userType"
                      class="custom-control-input"
                    />
                    <label class="custom-control-label" for="industry">
                      Industry
                    </label>
                  </div>

                  <div class="custom-control custom-radio">
                    <input
                      type="radio"
                      id="people"
                      value="People"
                      v-model="form.userType"
                      class="custom-control-input"
                    />
                    <label class="custom-control-label" for="people">
                      People
                    </label>
                  </div>
                </div>

                <!-- Industry Multi Select -->
                <div
                  class="form-group"
                  v-if="form.userType === 'Industry'"
                >
                  <label><strong>Select Industries</strong></label>

                  <select
                    class="form-control"
                    multiple
                    v-model="form.industries"
                  >
                    <option
                      v-for="industry in industries"
                      :key="industry.id"
                      :value="industry.id"
                    >
                      {{ industry.name }}
                    </option>
                  </select>

                  <small class="text-muted">
                    You can select multiple industries
                  </small>
                </div>
                <!-- Submit -->
                <div class="text-right">
                  <CButton
                    color="primary"
                    type="submit"
                    class="px-4"
                  >
                    <CIcon name="cil-paper-plane" class="mr-1" />
                    Send Notification
                  </CButton>
                </div>

              </CForm>
            </CCardBody>
          </CCard>

        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import {Mixin} from "/src/mixins/index.js";
import store from "/src/store/store.js";
import {  industry } from "/src/store/url.js";

export default {
  name: "NotificationManagement",
  mixins: [Mixin],
  data() {
    return {
      getColor: "",
      dismissCountDown: 0,
      msg: "",
      moduleIndustry: industry,
      form: {
        title: "",
        message: "",
        userType: "Industry",
        industries: [],
        send_email: false,
      },

      industries: [],
    };
  },
  mounted() {
    let self = this;
    axios.get(this.listUrlApi(this.moduleIndustry)).then((response) => {
      response.data.data.map(function (value, key) {
        if (value.industryId === "") {
          self.industries.push({id: value.id, name: value.industry});
        }
      });
    });
    store.commit('showLoader', false);
  },
  methods: {
    onSubmit() {      
      let self = this;
      self.msg = "Notification sent successfully";
      self.getColor = "success";
      self.dismissCountDown = 5;

      axios.post('/notifications/fire', this.form)
        .then((response) => {
          this.msg = response.data.message;
          this.getColor = "success";
          this.dismissCountDown = 5;
        })
        .catch((error) => {
          this.msg = "Something went wrong";
          this.getColor = "danger";
          this.dismissCountDown = 5;
        });
    },
  },
};
</script>

<style scoped>
.card {
  border-radius: 12px;
}

textarea {
  resize: none;
}

.custom-control-label {
  cursor: pointer;
}
</style>